import { css } from '../../../styles/theme';
import { breakpoints } from '../../../styles/DS/theme';
import { rem } from 'polished';

export const StylesDS = css`
    background-color: ${({ theme }) => theme.colors.white};
    text-align: left;

    .img-btn-container {
        border-radius: ${rem(8)};
        border-color: ${({ theme }) => theme.colors.milkshake};
        background: ${({ theme }) => theme.colors.white};

        img {
            margin-bottom: 0;
        }

        &.active {
            .description {
                display: none;
            }
        }
    }

    .my-account-page-title {
        @media (min-width: ${breakpoints.lg}px) {
            width: ${rem('1140px')};
        }

        h1 {
            font-size: ${rem('24px')};
            line-height: ${rem('36px')};
            text-transform: uppercase;
            margin: ${rem('30px')} 0;
        }
    }

    .my-account-breadcrumbs {
        color: ${({ theme }) => theme.colors.black};
        font-size: ${({ theme }) => theme.fontSizes.h6};

        a {
            color: ${({ theme }) => theme.colors.black};
        }

        span::before,
        a::before {
            color: ${({ theme }) => theme.colors.black};
        }
    }

    .link {
        color: ${({ theme }) => theme.colors.black};
    }

    .my-account-home {
        .imgbtn {
            margin-bottom: ${rem(10)};

            @media (min-width: ${breakpoints.sm}px) {
                margin-right: ${rem(10)};
            }
        }
    }

    .my-account-page {
        padding: ${rem(20)};

        @media (min-width: ${breakpoints.lg}px) {
            padding: ${rem(0)};
        }

        .my-account-content-title {
            font-weight: ${({ theme }) => theme.fontWeights.textRegular};
        }
    }
`;
